import React, { useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
} from "reactstrap";
import classnames from "classnames";
import { useLocation, useParams } from "react-router-dom";
import AcknowledgementLetter from "./AcknowledgementLetter";
import BonafideLetter from "./BonafideLetter";
import AdmissionCard from "./AdmissionCard";
import NoObjectionCertificate from "./NoObjectionCertificate";
import { useSelector } from "react-redux";
import AdmissionLetter from "./AdmissionLetter";
import FeeStructureLetter from "./FeeStructureLetter";
import DemandLetter from "./DemandLetter";
import PermissionCard from "./PermissionCard";
import FeeDefaultNoticeLetter from "./FeeDefaultNoticeLetter";

const LettersComponent = () => {
   const auth = useSelector((state) => state.authentication);
  const { branchData } = auth;

  const location = useLocation();
  const student = location.state?.student;

  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Container className="mt-4">
      <h5 className="mb-3">Letters for: {student?.name || "Student"}</h5>

      <Nav tabs>
          <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => toggle("1")}
          >
           Fees Structure
          </NavLink>
        </NavItem>
           <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => toggle("2")}
          >
           Admission
          </NavLink>
        </NavItem>
         <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "3" })}
            onClick={() => toggle("3")}
          >
            Acknowledgement Letter
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "4" })}
            onClick={() => toggle("4")}
          >
            Bonafide
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "5" })}
            onClick={() => toggle("5")}
          >
            Admission Card
          </NavLink>
           
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "6" })}
            onClick={() => toggle("6")}
          >
             No Objection Certificate
          </NavLink>  
        </NavItem>
          <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "7" })}
            onClick={() => toggle("7")}
          >
           Demand Letter
          </NavLink>  
        </NavItem>
         
          <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "8" })}
            onClick={() => toggle("8")}
          >
           Permission Card
          </NavLink>  
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "9" })}
            onClick={() => toggle("9")}
          >
            Fee Default Notice
          </NavLink>
        </NavItem>
        {/* Add more tabs if needed */}
      </Nav>


      <TabContent activeTab={activeTab} className="p-3 border border-top-0">
         <TabPane tabId="1">
      <FeeStructureLetter student={student} branchData={branchData} />
        </TabPane>
         <TabPane tabId="2">
      <AdmissionLetter student={student} branchData={branchData} />
        </TabPane>
        <TabPane tabId="3">
          <AcknowledgementLetter student={student} branchData={branchData}/>
          {/* Replace with your Bonafide form/component */}
     {    // Bonafide Letter Content/Form
     }
        </TabPane>
        <TabPane tabId="4">
         <BonafideLetter student={student} branchData={branchData} />
        </TabPane>
        <TabPane tabId="5">
         <AdmissionCard student={student} branchData={branchData} />
        </TabPane>
        <TabPane tabId="6">
         {/* Conduct Letter Component */}
         <NoObjectionCertificate student={student} branchData={branchData} />
        </TabPane>
         <TabPane tabId="7">
         {/* Conduct Letter Component */}
         <DemandLetter student={student} branchData={branchData} />
         
        </TabPane>
         <TabPane tabId="8">
           <PermissionCard student={student} branchData={branchData} />
           </TabPane>
           <TabPane tabId="9">
           <FeeDefaultNoticeLetter student={student} branchData={branchData} />
           </TabPane>
           
      </TabContent>
    </Container>
  );
};

export default LettersComponent;
